"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaLogCatraca = exports.yupLogCatraca = void 0;
const yup = __importStar(require("yup"));
const utils_1 = require("../../utils");
exports.yupLogCatraca = yup.object({
    carteira: yup.string().required().max(15).label('Carteirinha'),
    data: (0, utils_1.sge2Date)(),
    hora: yup.string().max(8).required().label('Hora'),
    catraca: yup.number().required().label('Número da catraca'),
    sentido: yup.string().max(1).label('Sentido'),
    tipo: yup.number().required().label('Tipo de pessoa'),
    status: yup.number().required().label('Status da passagem'),
    idAluno: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Aluno'),
    idFuncionario: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Funcionário'),
    idResponsavel: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Responsável'),
    idAlunoLogin: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .nullable()
        .label('Login Extra do Aluno'),
});
exports.schemaLogCatraca = exports.yupLogCatraca.shape({});
